<template>
  <div class="checkbox gap-2" @click="toggleCheckbox">
    <input
        class="checkbox__input"
        type="checkbox"
        :checked="modelValue"
        @change="$emit('update:modelValue', $event.target.checked)"
    />
    <label class="checkbox__label">{{ label }}</label>
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  label: String,
  modelValue: Boolean, // Измените на Boolean для чекбокса
})

const emit = defineEmits(['update:modelValue'])

const toggleCheckbox = () => {
  emit('update:modelValue', !props.modelValue)
}
</script>

<style scoped lang="scss">
.checkbox {
  display: flex;
  cursor: pointer;
  align-items: center;
  &__input {
    margin-left: 12px;
    position: relative;
    appearance: none;
    width: 18px;
    height: 18px;
    border: 1px solid $light-gray-2;
    border-radius: 4px;
    cursor: pointer;

    &::before {
      content: "";
      display: block;
      position: absolute;
      left: 2px;
      top: 1px;
      width: 14px;
      height: 14px;
      transform: scale(0);
      background-image: url('../../assets/images/icons/check.svg');
      background-size: contain;
    }

    &:checked {
      border-color: $blue;

      &::before {
        transform: scale(1);
      }
    }
  }

  &__label {
    cursor: pointer;
    font-weight: 400;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: 0;

  }
}
</style>